<template>
  <button
    class="title fixed bottom-[68px] right-[16px] z-[9999] inline-flex rounded-full !border-blue !bg-blue text-sm uppercase leading-none tracking-[.12em] text-white transition active:!border-blue-darker2 active:!bg-blue-darker2 hover:!opacity-100"
    type="button"
    :class="{
      'invisible opacity-0': !isButtonShowed,
      'visible opacity-50': isButtonShowed,
    }"
    @click="handleClick"
  >
    <span class="flex h-[44px] w-[44px] items-center justify-center">
      <UiIcon icon="arrowUp" class="h-4 w-4" />
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useWindowScroll, useWindowSize } from '@vueuse/core';

const { y: yScroll } = useWindowScroll();
const { height: windowHeight } = useWindowSize();
const isButtonShowed = computed(() => yScroll.value >= windowHeight.value);
const handleClick = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};
</script>
